import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GlobalAlertOptions } from '@model';
import { GlobalAlertService } from '@service';

@Component({
  selector: 'optima-global-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  isErrorAlertVisible: boolean;
  message: GlobalAlertOptions;

  constructor(private globalAlertService: GlobalAlertService) {
    this.isErrorAlertVisible = false;
  }
  ngOnInit(): void {
    this.globalAlertService.message$
      .pipe(
        switchMap(message => {
          this.message = message;
          this.isErrorAlertVisible = true;
          return timer(message.timeout);
        }),
      )
      .subscribe(() => {
        this.isErrorAlertVisible = false;
      });
  }

  protected hideBanner(): void {
    this.isErrorAlertVisible = false;
  }

  get isError(): boolean {
    return this.message.type === 'error';
  }

  get isWarning(): boolean {
    return this.message.type === 'warning';
  }

  get isSuccess(): boolean {
    return this.message.type === 'success';
  }

  get messageClassName(): {
    'alert-success': boolean;
    'global-message': true;
    alert: true;
    'alert-danger': boolean;
    'alert-warning': boolean;
  } {
    return {
      'global-message': true,
      alert: true,
      'alert-danger': this.isError,
      'alert-success': this.isSuccess,
      'alert-warning': this.isWarning,
    };
  }

  get iconClassName(): {
    'fa-ban': boolean;
    icon: true;
    fa: true;
    'fa-check-circle': boolean;
    'fa-circle-exclamation': boolean;
  } {
    return {
      icon: true,
      fa: true,
      'fa-ban': this.isError,
      'fa-check-circle': this.isSuccess,
      'fa-circle-exclamation': this.isWarning,
    };
  }
}
